var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"modal-mask"},[_c('div',{staticClass:"loadingscreen"},[_c('img',{attrs:{"src":require("@/img/loading_andes.gif")}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }